import React from 'react';
import '../../App.scss';

import { updateState , loadingStart, loadingComplete} from "../StateHelper";

import ProductApi from '../../api/ProductApi';
import BuyerApi from '../../api/BuyerApi';
import AdminBasketApi from '../../api/AdminBasketApi';

import AuthorizedPage from '../../component/AuthorizedPage';
import { Button, Dropdown, Table, Modal, Form } from 'react-bootstrap';
import UserProductListApi from '../../api/UserProductListApi';
import { Role } from '../../domain/Role';
import QuickSearchBox from '../../component/QuickSearchBox';
import InfoToast from '../../component/InfoToast';
import QuickFilterButton from '../../component/QuickFilterButton';

const initialState = {
  packagingGroups: new Array(),
  selectedPackagingGroup : "1500 GRAM",
  filteredProducts: new Array(),
  loadedProducts: new Array(),
  buyers: new Array(),
  selectedBuyer: new Object(),
  selectedBuyerID: null,
  basketIds: new Array(),
  selectedBasket: null,
  showToast : false,
  toastText : null,
  listMode: 'general',
  userListItems: [],
  allProductsForModal: [],
  showManageListModal: false,
  modalSearch: ''
};

class SaleProductBasketOrder extends React.Component<any,any> {

  constructor(props: any) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    this.init();
  }

  refresh() {
    this.setState(initialState);
    this.init();
  }

  init() {
    loadingStart(this);
    this.loadGeneralList();
    this.loadBuyers();
    this.loadProductPackagingGroups();
    loadingComplete(this)
  }

  async loadProducts(packagingGroup:any) {
    loadingStart(this);
    let response = await ProductApi.listAll(packagingGroup);
    if(response.success) {
      updateState(this, "loadedProducts", response.data);
      updateState(this, "filteredProducts", response.data);
    }
    loadingComplete(this)
  }

  async loadBuyers() {
    let response = await BuyerApi.listAll();
    if(response.success) {
      updateState(this, "buyersRaw", response.data);
      updateState(this, "buyers", response.data);
    }
  }

  async loadProductPackagingGroups() {
    let response = await ProductApi.listPackagingGroups();
    if(response.success) {
      updateState(this, "packagingGroups", response.data);
    }
  }

  onBuyerSelect = async (buyerId: any) => {
    const numericBuyerId = Number(buyerId);
    updateState(this, "selectedBuyerID", numericBuyerId);
    updateState(this, "selectedBasket", null);

    try {
      const response = await AdminBasketApi.listAllIdsByBuyerId(numericBuyerId);
      const basketIds = response?.success && Array.isArray(response.data) ? response.data : [];
      updateState(this, "basketIds", basketIds);

      if (basketIds.length > 0) {
        updateState(this, "selectedBasket", String(basketIds[0]));
      }
    } catch (error) {
      console.error("Basket API çağrısı başarısız:", error);
      updateState(this, "basketIds", []);
      updateState(this, "selectedBasket", null);
    }
  };

  async add2CartAsBox(buyerId: number, productId: number) {
    const enteredBoxQuantity = this.state["quantity_" + productId] || 1;

    const requestDTO = {
      buyerId: Number(buyerId),
      productId: Number(productId),
      quantity: enteredBoxQuantity,
      basketId: this.state.selectedBasket || null
    };

    try {
      const createResponse = await AdminBasketApi.createOrUpdate(requestDTO);

      if (createResponse.success) {
        updateState(this, "selectedBasket", createResponse.data.basketId);
        const response = await AdminBasketApi.listAllIdsByBuyerId(buyerId);
        const basketIds = response?.success && Array.isArray(response.data) ? response.data : [];
        updateState(this, "basketIds", basketIds);

        const newBasketId = Number(response.data?.basketId);

        updateState(this, "toastText", "Ürün sepete eklendi ✅");
      } else {
        updateState(this, "toastText", "Ürün sepete eklenemedi ❌");
      }
    } catch (err) {
      console.error("Sepete ekleme hatası:", err);
      updateState(this, "toastText", "Bağlantı hatası: Ürün sepete eklenemedi ❌");
    }

    updateState(this, "showToast", true);
  }

  async onPagerChange(page:any) {
    let response = await ProductApi.listAll(page);
    if(response.success) {
      updateState(this, "loadedProducts", response.data);
      updateState(this, "filteredProducts", response.data);
    }
  }

  async onPackagingGroupChange(event:any) {
    updateState(this, "selectedPackagingGroup", event);
    this.loadProducts(event);
  }

  renderBuyerSelectBox = () => {
    const sample = this.state.buyers;
    const dropDownItems = sample && sample.map((item: any) => (
      <Dropdown.Item key={item.id} eventKey={item.id}>
        {item.title || ""} {item.name || ""}
      </Dropdown.Item>
    ));

    let toggleMessage = "Müşteri Seçiniz";
    if (this.state.selectedBuyerID) {
      const buyer = this.state.buyers.find((item: any) => this.state.selectedBuyerID === item.id);
      if (buyer) toggleMessage = (buyer.title || "") + " " + (buyer.name || "");
    }

    return (
      <div className="row" style={{ margin: "22px" }}>
        <div className="col-md-12" style={{ marginLeft: "-30px" }}>
          <Dropdown onSelect={(eventKey: any) => this.onBuyerSelect(eventKey)}>
            <Dropdown.Toggle variant="danger" id="dropdown-basic" style={{ width: "250px", minWidth: "250px", height: "38px" }}>
              <span>{toggleMessage}</span>
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ padding: "10px" }}>
              <QuickSearchBox
                style={{ width: "100%", marginBottom: "10px" }}
                items={this.state.buyersRaw}
                onSearch={(filtered: any) => updateState(this, "buyers", filtered)}
              />
              <Dropdown.Divider />
              {dropDownItems}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    );
  }

  renderProducts = () => {
    return <Table striped bordered hover>
      <thead>
        <tr>
          <th>Stok Kodu</th>
          <th>Barcode</th>
          <th>Adı</th>
          <th>Sepette Bek. Adet</th>
          <th>Siparişte Bek. Adet</th>
          <th>Koli Kadar Ekle</th>
          <th>Sepete Ekle</th>
        </tr>
      </thead>
      <tbody>
        {this.renderProductRows(this.state.filteredProducts)}
      </tbody>
    </Table>;
  };

  renderProductRows = (products:any) => {
    return products && products.map((it:any) => {
      return <tr key={it.id + it.name}>
        <td>{it.stockCode}</td>
        <td>{it.barcode}</td>
        <td>{it.name} {'[ Kolideki Adet: ' + it.quantityInsideBox + ' ]'}</td>
        <td>{it.waitingInBasketStockCount}</td>
        <td>{it.waitingInOrderStockCount}</td>
        <td>
          <input type="number" style={{width:"65px"}} id={"id_quantity_"+it.id} name={"quantity_"+it.id} value={this.state["quantity_"+it.id]} min="1" defaultValue="1" onChange={e => updateState(this, "quantity_"+it.id, new Number(e.target.value))}/>
          <br/>
          {' '+(it.quantityInsideBox || 1) * (this.state["quantity_"+it.id] || 1) + ' Tekil Adet'}
        </td>
        <td>
          <Button size="sm" variant="outline-success" disabled={(!this.state.selectedBuyerID)} onClick={() => this.add2CartAsBox(this.state.selectedBuyerID, it.id)}>Sepete Ekle</Button>
        </td>
      </tr>
    });
  };

  renderSearchBox = () => {
    return (
      <div className="search-row">
        <div className="search-container">
          <input
            type="text"
            placeholder="Ara..."
            onChange={(e) => this.onSearch(e.target.value)}
            className="search-input"
          />
          <div className="search-icon" />
        </div>
      </div>
    );
  };



  renderBasketDropdown = () => {
    const { basketIds, selectedBasket } = this.state;
    if (!basketIds) return null;

    const dropdownOptions = ["Yeni Sepet", ...basketIds];
    const toggleText = selectedBasket || "Yeni Sepet";

    return (
      <div className="row" style={{ margin: "22px" }}>
        <div className="col-md-12" style={{ marginLeft: "-30px" }}>
          <Dropdown
            onSelect={(eventKey: any) => {
              if (eventKey === "Yeni Sepet") {
                updateState(this, "selectedBasket", null);
              } else {
                // eventKey string gelir, numaraya çevir
                const parsedKey = isNaN(eventKey) ? eventKey : Number(eventKey);
                updateState(this, "selectedBasket", parsedKey);
              }
            }}
          >
            <Dropdown.Toggle
              variant="secondary"
              id="dropdown-basket"
              style={{ width: "250px", minWidth: "250px", height: "38px" }}
            >
              <span>{toggleText}</span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {dropdownOptions.map((item: any, index: number) => {
                const parsedItem = isNaN(item) ? item : Number(item);
                const isActive =
                  (selectedBasket === null && item === "Yeni Sepet") ||
                  parsedItem === selectedBasket;

                return (
                  <Dropdown.Item key={index} eventKey={item} active={isActive}>
                    {item}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    );
  };

  async loadGeneralList() {
    loadingStart(this);
    let response = await ProductApi.basketList();
    if (response.success) {
      updateState(this, "loadedProducts", response.data);
      updateState(this, "filteredProducts", response.data);
    }
    loadingComplete(this);
  }

  loadPersonalListItems = async () => {
    const response = await UserProductListApi.getItems();
    if (response.success) {
      updateState(this, "userListItems", response.data);
      if (this.state.listMode === 'personal') {
        const products = (response.data as any[]).map((item: any) => item.product);
        updateState(this, "loadedProducts", products);
        updateState(this, "filteredProducts", products);
      }
    }
  };

  async loadPersonalList() {
    loadingStart(this);
    await this.loadPersonalListItems();
    loadingComplete(this);
  }

  onListModeChange = (mode: 'general' | 'personal') => {
    updateState(this, "listMode", mode);
    updateState(this, "loadedProducts", []);
    updateState(this, "filteredProducts", []);
    if (mode === 'general') {
      this.loadGeneralList();
    } else {
      this.loadPersonalList();
    }
  };

  openManageModal = async () => {
    updateState(this, "showManageListModal", true);
    updateState(this, "modalSearch", "");
    if (!this.state.allProductsForModal || this.state.allProductsForModal.length === 0) {
      const response = await ProductApi.basketList();
      if (response.success) {
        updateState(this, "allProductsForModal", response.data);
      }
    }
    await this.loadPersonalListItems();
  };

  addToPersonalList = async (productId: number) => {
    const response = await UserProductListApi.addItem(productId);
    if (response.success) {
      await this.loadPersonalListItems();
      updateState(this, "toastText", "Ürün listeye eklendi ✅");
    } else {
      updateState(this, "toastText", "Ürün zaten listede veya eklenemedi ❌");
    }
    updateState(this, "showToast", true);
  };

  removeFromPersonalList = async (itemId: number) => {
    const response = await UserProductListApi.removeItem(itemId);
    if (response.success) {
      await this.loadPersonalListItems();
    }
  };

  renderListModeTabs = () => {
    return (
      <div className="d-flex align-items-center gap-2 mb-3">
        <Button
          variant={this.state.listMode === 'general' ? 'primary' : 'outline-primary'}
          style={{ borderRadius: "20px" }}
          onClick={() => this.onListModeChange('general')}
        >
          Genel Liste
        </Button>
        <Button
          variant={this.state.listMode === 'personal' ? 'primary' : 'outline-primary'}
          style={{ borderRadius: "20px" }}
          onClick={() => this.onListModeChange('personal')}
        >
          Özel Liste
        </Button>
        {this.state.listMode === 'personal' && (
          <Button
            variant="outline-secondary"
            style={{ borderRadius: "20px" }}
            onClick={this.openManageModal}
          >
            Özel Listemi Düzenle
          </Button>
        )}
      </div>
    );
  };

  renderManageListModal = () => {
    const { userListItems, allProductsForModal, modalSearch, showManageListModal } = this.state;
    const userListProductIds = new Set((userListItems as any[]).map((item: any) => item.product?.id));

    const filteredForModal = (allProductsForModal as any[]).filter((p: any) =>
      !modalSearch ||
      p.name?.toLocaleLowerCase("tr").includes(modalSearch.toLocaleLowerCase("tr")) ||
      p.stockCode?.toLocaleLowerCase("tr").includes(modalSearch.toLocaleLowerCase("tr"))
    );

    return (
      <Modal size="lg" show={showManageListModal} onHide={() => updateState(this, "showManageListModal", false)}>
        <Modal.Header closeButton>
          <Modal.Title>Özel Listemi Düzenle</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6>Listedeki Ürünler</h6>
          {(userListItems as any[]).length === 0 ? (
            <p className="text-muted">Listenizde ürün bulunmuyor.</p>
          ) : (
            <Table size="sm" bordered>
              <thead>
                <tr>
                  <th>Ürün Adı</th>
                  <th>Stok Kodu</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {(userListItems as any[]).map((item: any) => (
                  <tr key={item.id}>
                    <td>{item.product?.name}</td>
                    <td>{item.product?.stockCode}</td>
                    <td>
                      <Button size="sm" variant="outline-danger" onClick={() => this.removeFromPersonalList(item.id)}>
                        Çıkar
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}

          <hr />

          <h6>Ürün Ekle</h6>
          <Form.Control
            type="text"
            placeholder="Ara..."
            className="mb-2"
            value={modalSearch}
            onChange={(e) => updateState(this, "modalSearch", e.target.value)}
          />
          <div style={{ maxHeight: "300px", overflowY: "auto" }}>
            <Table size="sm" bordered>
              <thead>
                <tr>
                  <th>Ürün Adı</th>
                  <th>Stok Kodu</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filteredForModal.map((p: any) => (
                  <tr key={p.id}>
                    <td>{p.name}</td>
                    <td>{p.stockCode}</td>
                    <td>
                      <Button
                        size="sm"
                        variant={userListProductIds.has(p.id) ? "secondary" : "outline-success"}
                        disabled={userListProductIds.has(p.id)}
                        onClick={() => this.addToPersonalList(p.id)}
                      >
                        {userListProductIds.has(p.id) ? "Eklendi" : "Ekle"}
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  onSearch = (searchText:any) => {
    let filtered = this.state.loadedProducts && this.state.loadedProducts.filter((it:any) => {
      return Object.values(it).join(';').toLocaleLowerCase("tr").includes(searchText.toLocaleLowerCase("tr"));
    });
    updateState(this,"filteredProducts", filtered);
  }

  render() {
    const buyerSelectBox = this.renderBuyerSelectBox();

    return (
      <AuthorizedPage
        role={Role.ORDER_MANAGER}
        isLoading={this.state.isLoading}
      >
        <InfoToast
          onClose={() => updateState(this,"showToast", false)}
          show={this.state.showToast}
          text={this.state.toastText}
        />

        <div className="centered-95-percent">

          {/* ===== Sayfa Başlığı ===== */}
          <div className="mb-3">
            <h3 className="mb-0">🛒 Sipariş Sepeti Oluşturma</h3>
          </div>

          {/* ===== Liste Seçimi ===== */}
          {this.renderListModeTabs()}

          {/* ===== Arama + Seçimler (AYNI SATIR) ===== */}
          <div
            className="d-flex align-items-center gap-3 mb-3"
          >
            {/* Arama */}
            <div style={{ width: "300px" }}>
              {this.renderSearchBox()}
            </div>

            {/* Müşteri Seç */}
            {buyerSelectBox}

            {/* Sepet Seç */}
            {this.renderBasketDropdown()}
          </div>

          {/* ===== Tablo ===== */}
          {this.renderProducts()}

        </div>

        {this.renderManageListModal()}
      </AuthorizedPage>
    );
  }

}

export default SaleProductBasketOrder;
